const { h, Component } = require("preact");
import { select, scaleLinear } from 'd3';
import { formatNumberPct, formatNumberWithCommas } from '../../utils/utils';

class BarLegend extends Component {
    constructor() {
      super();
  
      this.state = {
      }
    }

    drawLegend(){
        const container = select(`.categories-bars-legend`)
        const width = container.node().clientWidth;
        const height = 30;
        const margin = {t: 31, l: 0};

        const svg = container
            .append('svg')
            .attr('width', width)
            .attr('height', height)

        const legend = svg.append('g')
            .attr('class', 'legend');
        
        legend.append('rect')
            .attr('class','key')
            .attr('x',0)
            .attr('y', 0)
            .attr('width', 17)
            .attr('height', 17)
            .attr('fill', '#ffc200')
            .attr('fill-opacity', 0.7)
        legend.append('text')
            .attr('class','key-text')
            .attr('x', 21)
            .attr('dy',12)
            .attr('text-anchor', 'start')
            .text('Early votes')
            .attr('fill', 'black')
            .style('font-size', '12px')
        legend.append('rect')
            .attr('class','key')
            .attr('x',90)
            .attr('y', 0)
            .attr('width', 17)
            .attr('height', 17)
            .attr('fill', '#3fa293')
            .attr('fill-opacity', 0.7)
        legend.append('text')
            .attr('class','key-text')
            .attr('x', 111)
            .attr('dy',12)
            .attr('text-anchor', 'start')
            .text('Election day votes')
            .attr('fill', 'black')
            .style('font-size', '12px')
    }

    redrawLegend() {
        select(`.categories-bars-legend`)
          .select('svg')
          .remove()
        select(`.categories-bars-legend`)
          .select('.text')
          .remove()
        this.drawLegend(); 
      }

    componentDidMount() {
        this.drawLegend();
    
        window.addEventListener('resize', () => {
          this.redrawLegend();
        })
      }

    render() {   
        return (
          <div class='categories-bars-legend'></div>
        )
      }
}

export default BarLegend;